export default __webpack_public_path__ + "static/media/discard_and_close.4210e3aa.svg";